<template>
    <div>
        <vue-element-loading :active="isLoading" is-full-screen text="Please wait..." />
        <div >
            <b-button variant="outline-secondary" @click="downloadRowCSV" style="margin-left:20px;">EXPO</b-button>
            <lineChart
                :chart-data="lineChartData"
                class="chart-height"
            ></lineChart>
        </div>
        <div class="report-box" style="margin-top:20px;">
            <!-- <vue-element-loading :active="isLoading2" text="Please wait..." /> -->
            <div>
                <div>
                    <table class="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>RR_Avg(ms)</th>
                                <th>RR_V(%)</th>
                                <th>{{$t("txt_1")}}</th>
                                <th>{{$t("txt_2")}}</th>
                                <th>f1(HZ)</th>
                                <th>f2(HZ)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <td class="title">Vlaue</td>
                            <td v-for="(item, index) in reportOri" :key="index">{{item}}</td>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="report-box" style="margin-top:40px;">
                <div>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>FiveOrder</th>
                                <th>A1(x)</th>
                                <th>A2(x)</th>
                                <th>A3(x)</th>
                                <th>B1(x)</th>
                                <th>B2(x)</th>
                                <th>B3(x)</th>
                                <th>C1(x)</th>
                                <th>C2(x)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <td class="title">{{$t("txt_6")}}</td>
                            <td v-for="(item, index) in reportFiveOrder" :key="index">{{item}}</td>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LineChart from '@/components/chart/lineChart.vue';
export default {
    components: {
        LineChart
    },
    data() {
        return {
            type: this.$route.query.type,
            report_id: '',
            db_model: 'db',
            lineChartData: {
                labels: [],
                datasets: []
            },
            reportOri: [],
            reportFiveOrder: [],
            isLoading: false,
            // isLoading2: false,
        }
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.report_id = report.id;
        if(this.type == 'client') {
            this.db_model = 'db'
        }else{
            this.db_model = 'irb_db'
        }
        this.getReport();
        this.getReportOriV1();
    },
    methods: {
        getReportOriV1() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/ori`;
            const json = {
                report_id: this.report_id,
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    const jsonData = JSON.parse(res.data.data);
                    this.reportOri = jsonData;
                    this.getReportFiveOrder();
                }
                this.isLoading = false;
            })
        },
        getReportFiveOrder() {
            const api = `${process.env.VUE_APP_APIPATH}/client/report/fiveorder`;
            const json = {
                report_id: this.report_id,
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.reportFiveOrder = res.data.data;
                }
                this.isLoading = false;
            })
        },
        getReport() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/pulse`;
            const json = {
                report_id: this.report_id,
                db_model: this.db_model
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.drawPulse(res.data.data);
                }
                this.isLoading = false
            })
        },
        downloadRowCSV() {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/client/report/row/csv`;
            const json = {
                report_id: this.report_id,
                db_model:"db"
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    const url = res.data.data;
                    window.open(url, '_blank')
                    this.isLoading = false;
                }
            })
        },
        drawPulse(pulse) {
            let pulseAry = [];
            let labAry = [];
            pulseAry = pulse;
            
            pulseAry.splice(0, 1);
            pulse = pulseAry.join(",");
            pulseAry.forEach((item, i) => {
                labAry.push(i);
            })
            
            let result = {
                labels: labAry,
                datasets: [
                {
                    label: 'Original',
                    backgroundColor: "transparent",
                    data: pulseAry,
                    borderColor: "rgba(29, 33, 36, .2)",
                    pointBackgroundColor: "rgba(171, 71, 188, 1)",
                    pointRadius: 1,
                }
                ]
            };
            this.lineChartData = result;
        },
    }
}
</script>